<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-room-dining"></div>
    <div class="position-relative z-index-1028 bg-white" v-if="scrollPosition >20">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white">
                  <div class="container px-4 w-100 pt-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1 align-self-center">
                        <router-link :to="'/'+getMerchant.code" class="d-inline-grid">
                          <img src="../../../../assets/img/icon/back.png" class="mt-1 top-2" width="20">
                        </router-link>
                      </div>
                      <div class="col-9 align-self-center">
                        <transition name="fade">
                          <p class="mb-0 body-1-2 ml-1 text-truncate">{{data.general.tagline}}</p>
                        </transition>
                      </div>
                      <div class="col-2 text-right align-self-center">
                        <router-link :to="'/'+getMerchant.code+'/concierge/room-dining/search'">
                          <div class="rounded-100 inline-grid border-semi-grey d-inline-grid" style="padding:6px">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="16">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H16.1076V16.1077H1.5V1.5Z" fill="white"/>
                              </mask>
                              <g mask="url(#mask0_3948_11251)">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80425 2.625C5.397 2.625 2.625 5.39625 2.625 8.8035C2.625 12.2107 5.397 14.9827 8.80425 14.9827C12.2107 14.9827 14.9827 12.2107 14.9827 8.8035C14.9827 5.39625 12.2107 2.625 8.80425 2.625M8.80425 16.1077C4.77675 16.1077 1.5 12.831 1.5 8.8035C1.5 4.776 4.77675 1.5 8.80425 1.5C12.8318 1.5 16.1077 4.776 16.1077 8.8035C16.1077 12.831 12.8318 16.1077 8.80425 16.1077" fill="#222222"/>
                              </g>
                              <mask id="mask1_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="13" width="5" height="5">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9302 13.2803H16.6982V17.0413H12.9302V13.2803Z" fill="white"/>
                              </mask>
                              <g mask="url(#mask1_3948_11251)">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1359 17.0413C15.9926 17.0413 15.8486 16.9866 15.7384 16.8771L13.0954 14.2416C12.8756 14.0218 12.8749 13.6656 13.0946 13.4458C13.3136 13.2246 13.6699 13.2261 13.8904 13.4443L16.5334 16.0806C16.7531 16.3003 16.7539 16.6558 16.5341 16.8756C16.4246 16.9866 16.2799 17.0413 16.1359 17.0413" fill="#222222"/>
                              </g>
                            </svg>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- HEADER BEST MENU -->
    <div v-if="is_load.general" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error.general != ''" :message="error.general" />
      <template v-else>
        <div class="container px-4 pt-4">
          <div class="row no-gutters">
            <div class="col-1">
              <router-link :to="'/'+getMerchant.code" class="d-inline-grid position-relative" style="top: 10px;">
                <img src="../../../../assets/img/icon/back.png" class="mt-1" width="20">
              </router-link>
            </div>
            <div class="col-9">
              <div class="ml-2-back">
                <p class="mb-0 heading-6-1 text-18" @click="loadMoreProductCategory()">{{data.general.tagline}}</p>
                <p class="mb-0 body-2-2-1">{{data.general.sub_tagline}}</p>
              </div>
            </div>
            <div class="col-2 text-right">
              <router-link :to="'/'+getMerchant.code+'/concierge/room-dining/search'">
                <div class="rounded-100 inline-grid border-semi-grey d-inline-grid position-relative" style="padding:6px;top:4px">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="16">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H16.1076V16.1077H1.5V1.5Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_3948_11251)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80425 2.625C5.397 2.625 2.625 5.39625 2.625 8.8035C2.625 12.2107 5.397 14.9827 8.80425 14.9827C12.2107 14.9827 14.9827 12.2107 14.9827 8.8035C14.9827 5.39625 12.2107 2.625 8.80425 2.625M8.80425 16.1077C4.77675 16.1077 1.5 12.831 1.5 8.8035C1.5 4.776 4.77675 1.5 8.80425 1.5C12.8318 1.5 16.1077 4.776 16.1077 8.8035C16.1077 12.831 12.8318 16.1077 8.80425 16.1077" fill="#222222"/>
                    </g>
                    <mask id="mask1_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="13" width="5" height="5">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9302 13.2803H16.6982V17.0413H12.9302V13.2803Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask1_3948_11251)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1359 17.0413C15.9926 17.0413 15.8486 16.9866 15.7384 16.8771L13.0954 14.2416C12.8756 14.0218 12.8749 13.6656 13.0946 13.4458C13.3136 13.2246 13.6699 13.2261 13.8904 13.4443L16.5334 16.0806C16.7531 16.3003 16.7539 16.6558 16.5341 16.8756C16.4246 16.9866 16.2799 17.0413 16.1359 17.0413" fill="#222222"/>
                    </g>
                  </svg>
                </div>
              </router-link>
            </div>
          </div>
        </div>


        <!-- CATEGORY -->
        <div class="container px-4 pt-2 sticky bg-white" :class="{'box-shadow-nav pb-1':scrollPosition >20}" style="top: 50px;z-index: 1038">
          <flickity ref="flickity" class="flickity-category" :options="slider_option.category">
            <div class="carousel-cell-category" 
              v-for="(cat, index) in data.category" @click="changeCategory(cat)" style="width: max-content;">
             <p class="body-3 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer bg-light-page radius-6" :class="{'font-bold delay bg-green text-white border-green':cat.id == data.category_selected.id}">{{cat.name}}</p>
            </div>
          </flickity>
        </div>

        <template v-if="data.category_selected.id == 'all'">
          <!-- SLIDER -->
          <div class="pt-2 mb-4">
            <flickity ref="flickity" class="room-dining" :options="flickityOptions">
              <div class="carousel-cell w-80 mr-3" :class="{'pl-4':index == 0, 'pr-4':index == data.general.slider_list.length - 1}" v-for="(slider,index) in data.general.slider_list">
                <div class="w-100 h-image-promo">
                  <img :src="slider.image_url" class="img-fit rounded-6">
                </div>
              </div>
            </flickity>
          </div>

          <!-- BEST MENU -->
          <div class="container px-4 mb-3" v-if="data.best_menu.length > 0 && !isMembershipRewardApplied">
            <div class="mb-3">
              <p class="mb-0 sub-heading-1-1">{{data.general.best_menu_tagline}}</p>
              <p class="mb-0 body-2-2-1">{{data.general.best_menu_sub_tagline}}</p>
            </div>
            <div class="row slim-grid-row">
              <div class="col-6 mb-4" v-for="best_menu in data.best_menu">
                <MenuFoodSquare :data="best_menu"></MenuFoodSquare>
              </div>
            </div>
          </div>
        </template>
      </template>
    </template>

    <!-- ALL PRODUCT -->
    <div class="container pt-2 px-4 mb-2">
      <div v-if="is_load.all_product" class="w-100 py-4 text-center">
        <loader v-if="!is_load.general" />
      </div>
      <template v-else>
        <ErrorMessage v-if="error.all_product != ''" :message="error.all_product" />
        <template v-else>
          <ClaimingReward wrapper_class="mb-4"></ClaimingReward>
          
          <div class="mb-3" v-for="category_product in data.product_category">
            <div class="mb-3">
              <p class="mb-0 sub-heading-1-1">{{category_product.name}}</p>
              <p class="mb-0 body-2-2-1">{{category_product.description}}</p>
            </div>
            <div class="row slim-grid-row">
              <div class="col-6 mb-4" v-for="product_per_category in category_product.product">
                <MenuFoodSquare :data="product_per_category"></MenuFoodSquare>
              </div>
            </div>
           <!--  <div class="w-100" v-if="data.category_selected.id == 'all' && category_product.total_product > 2">
              <p class="d-table px-2 py-1 mb-0 body-3-3 font-semibold text-orange ml-auto border-orange rounded-4 cursor-pointer" @click="changeCategory({id:category_product.id,name:category_product.name})">Load more</p>
            </div> -->
          </div>

          <infinite-loading v-if="data.product_category.length < data.all_product.length" :forceUseInfiniteWrapper="true" spinner="spiral" @infinite="lazyloadMoreProductCategory">
            <div slot="no-more"> </div>
            <div slot="no-results"> </div>
          </infinite-loading>
        </template>
      </template>
    </div>

    <!-- Detail Menu -->
    <transition name="fade">
      <menuDetail v-if="data.selected_product_id != ''" @done="changeProductSelected" :product_id="data.selected_product_id"></menuDetail>
    </transition>

    <!-- Pop Up Cart -->
    <cartPopup :full_bottom="true"></cartPopup>
    <div class="height-63px" v-if="getConciergeOrder.cart.length > 0"></div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import Flickity from 'vue-flickity';
  import MenuFoodSquare from '@/components/hotel/concierge/general/MenuFoodSquare'
  import menuSmallImage from '@/components/hotel/concierge/general/menuSmallImage'
  import menuDetail from '@/components/hotel/concierge/general/menuDetail'
  import cartPopup from '@/components/hotel/concierge/general/cartPopup'
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';

  export default{
    components: {
      Flickity,
      MenuFoodSquare,
      menuSmallImage,
      menuDetail,
      cartPopup,
      ClaimingReward
    },
    data() {
      return {
        scrollPosition: null,
        is_popup: '',
        is_cart: false,
        counter: 1,
        detail_menu: {},
        is_category: 1,
        is_variant: 1,
        is_scroll: '',
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: true
        },


        // fix
        is_load: {
          general: true,
          all_product: true
        },
        error: {
          general: '',
          all_product: ''
        },
        data:{
          general: {},
          category: [],
          category_selected: {
            id: 'all',
            name: this.$t('general.all-categories')
          },
          best_menu: [],
          all_product: [],
          selected_product_id: '',
          product_category: []
        },
        slider_option:{
          category:{
            initialIndex: 0,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: true,
            freeScroll: true,
            cellAlign: 'left'
          }
        },
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getMetaTitleTemplate',
        'getConciergeOrder',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied'])
    },
    created(){
      this.$validateActiveReward('concierge-room-dining')
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-room-dining').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadGeneralSetting()
      this.loadAllMenu()
    },
    methods: {
      ...mapMutations(['setMembershipRewardApplied']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
      },
      toMenu(data, type){
        if (type == 'close') {
          this.is_popup = false
        }else{
          this.is_popup = type
          this.detail_menu = data
          this.is_scroll = data.name
        }
      },
      toCart(){
        this.is_cart = true
        this.is_popup = 'close'
      },
      selectTopping(id){
        for(let i in this.topping){
          if (this.topping[i].id == id) {
            this.topping[i].select = !this.topping[i].select
            break;
          }
        }
      },
      scrollTo(){
        console.log(this.is_scroll)
        document.getElementById(this.is_scroll).scrollIntoView({
          behavior: 'smooth'
        });
      },
      changeCategory(data){
        this.data.category_selected = data
        if(data.id == 'all'){
          this.loadBestMenu()
        }
        this.loadAllMenu()
      }, 
      changeProductSelected(data_detail=false){
        this.data.selected_product_id = data_detail == false ? '' : data_detail.id
      },

      // INFINITE SCROLL
      loadMoreProductCategory(){
        return new Promise((resolve, reject) => {      
          let total = this.data.all_product.length
          let start = this.data.product_category.length 
          let end = start + 3
          if(start < total){
            let copy_arr = this.$deepCopy(this.data.all_product)
            let new_arr = copy_arr.slice(start, end)
            this.data.product_category.push(...new_arr);
          }
          resolve()
        });
      },
      lazyloadMoreProductCategory($state){
        let total = this.data.all_product.length
        let start = this.data.product_category.length 
        if(start >= total) $state.complete()
        else this.loadMoreProductCategory().then(() => $state.loaded())
      },


      // API FUNCTION
      loadGeneralSetting(){
        this.is_load.general = true
        this.error.general = ''
        this.data.general = {}

        get("CONCIERGE","room-dining/general",{
          merchant_id: this.getMerchant.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data.general = res.data
            this.loadProductCategory()
          }else{
            this.error.general = res.message
            this.is_load.general = false
          }
        })
      },
      loadProductCategory(){
        this.data.category = []
        get("CONCIERGE", "room-dining/category-option",{
          merchant_id: this.getMerchant.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data.category.push({
              id: 'all',
              name: this.$t('general.all-categories')
            })
            for(let cat of res.data){
              this.data.category.push(cat)
            }
            this.data.category_selected = this.data.category[0]
            this.loadBestMenu()
          }else{
            this.error.general = res.message
            this.is_load.general = false
          }
        })
      },
      loadBestMenu(){
        this.data.best_menu = []
        get("CONCIERGE", "room-dining/product-best",{
          merchant_id: this.getMerchant.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data.best_menu = res.data
          }else{
            this.error.general = res.message
          }
          this.is_load.general = false
        })
      },
      loadAllMenu(){
        this.is_load.all_product = true
        this.error.all_product = ''
        this.data.all_product = []
        get("CONCIERGE", "room-dining/product",{
          merchant_id: this.getMerchant.id,
          category_id: this.data.category_selected.id == 'all' ? '' : this.data.category_selected.id,
          membership_reward_id: this.isMembershipRewardApplied ? this.getMembershipRewardApplied.id : ''
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data.all_product = res.data
            this.data.product_category = []
            this.loadMoreProductCategory()
          }else{
            this.error.all_product = res.message
          }
          this.is_load.all_product = false
        })
      }
    }
  }
</script>
<style scoped>
.search-custom {
  background-image: url('../../../../assets/img/hotel/search.png');
  height: 44px;
  background-color: #f4f4f4b8  !important;
  background-position: 16px 14px;
  background-size: 15px 15px;
  -o-object-fit: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 5px 30px 7px 44px;
}

ol.flickity-page-dots{
  text-align: left!important;
}

.left-0-d{
  left: 0!important
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
} 
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/roomdining/RoomDining.vue